import image1 from "../assets/t-image1.jpg";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";
import image4 from "../assets/t-image4.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Mokhele Fitness Club and by choosing the right plan and program I already achieved my ideal body!",
    name: "SIMON BAARDMAN",
    status: "ENTREPRENEUR",
  },
  {
    image: image2,
    review:
      "Signing up with Mokhele Fitness Club was one of the best things I have ever done! Dave my trainer has helped me achieve my goals so far and I love our sessions. He makes it fun and enjoyable to train and he is very motivating and encouraging!",
    name: "JOHN KEVIN",
    status: "COACH",
  },
  {
    image: image3,
    review:
      "If motivation, flexibility, and a personal approach is what your looking for in a PT, then Sam is the man for you! The guys at Mokhele Fitness Club Personal Training are a professional outfit I can highly recommend",
    name: "SIBONGILE KHUMALO",
    status: "CUSTOMER",
  },
  {
    image: image4,
    review:
      "Not having an active workout schedule in the past, Dave has been a great PT in supporting my training objectives. He is outcome focused, and I have been able to see continual improvement from my sessions, which are run in a relaxed yet supportive environment.",
    name: "ANNGELA MOTAUNG",
    status: "PROPERTY DEVELOPER",
  },
];
